module.exports = __webpack_public_path__ + "static/img/francoPassarin.33784b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/francoPassarin.png
// module id = xcup
// module chunks = 1